import Axios from "axios";
import useStore from "zustand-store";

const instance = Axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL,
    headers: process.env.REACT_APP_CLIENT_PASSWORD_FOR_CLIENT_AUTH !== undefined ? {
      common: {
        'X-Custom-Client-Auth' : process.env.REACT_APP_CLIENT_PASSWORD_FOR_CLIENT_AUTH
      }
    } : undefined
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const returnCode = error?.response?.data?.returnCode;
    if (returnCode === "WRONG_ACCESS_TOKEN") {
      useStore().logoutFront();
    }
    return Promise.reject(error);
  }
);


export default instance;